import { Commands } from '.';
var MessageBox = (function () {
    function MessageBox(data) {
        this.myInput = data.parameters.input;
        this.myInputRequest = data.parameters.inputRequest;
        this.myCaption = data.parameters.caption;
        this.myText = data.parameters.text;
        this.myButtons = data.parameters.buttons;
        this.myIcons = data.parameters.icons;
    }
    Object.defineProperty(MessageBox.prototype, "sender", {
        get: function () {
            return this.mySender;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBox.prototype, "action", {
        get: function () {
            return this.myAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBox.prototype, "name", {
        get: function () {
            return Commands.MessageBox;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBox.prototype, "input", {
        get: function () {
            return this.myInput;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBox.prototype, "inputRequest", {
        get: function () {
            return this.myInputRequest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBox.prototype, "caption", {
        get: function () {
            return this.myCaption;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBox.prototype, "text", {
        get: function () {
            return this.myText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBox.prototype, "buttons", {
        get: function () {
            return this.myButtons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBox.prototype, "icons", {
        get: function () {
            return this.myIcons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBox.prototype, "status", {
        get: function () {
            return 'modal-overlay dialog dialog-open';
        },
        enumerable: false,
        configurable: true
    });
    return MessageBox;
}());
export { MessageBox };
